<template>
    <component
        :is="tooltipComponent"
        v-bind="tooltipProps"
    >
        <IconButton
            icon="discord"
            color="carbon-400"
            interfaceTarget="discord-button"
            :externalTo="DISCORD_URL"
            target="_blank"
        />
        <template #content>
            <TooltipContent
                :image="DiscordImage"
                :title="$tr('gameContainer.discord_popup_header')"
                :description="$tr('gameContainer.discord_popup_description')"
            >
                <Button
                    interfaceTarget="discord-button"
                    :externalTo="DISCORD_URL"
                    target="_blank"
                    width="full"
                    :label="$tr('gameContainer.discord_popup_button')"
                />
            </TooltipContent>
        </template>
    </component>
</template>

<script setup lang="ts">
import { useMounted } from '@vueuse/core'
import { computed } from 'vue'

import Button from '@/components_new/Buttons/Button.vue'
import IconButton from '@/components_new/Buttons/IconButton.vue'
import TooltipPopup from '@/components_new/Tooltip/TooltipPopup.vue'

import { DISCORD_URL } from '../constants'
import DiscordImage from './images/discord.webp'
import TooltipContent from './TooltipContent.vue'

const props = defineProps<{ className: string }>()

const isMounted = useMounted()

const tooltipComponent = computed(() => (isMounted.value ? TooltipPopup : 'div'))

const tooltipProps = computed(() =>
    isMounted.value
        ? {
              interfaceTarget: 'discord-button',
              triggerClass: props.className,
          }
        : {
              class: props.className,
          },
)
</script>
